'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _flattenProp = require('recompose/flattenProp');

var _flattenProp2 = _interopRequireDefault(_flattenProp);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _linkHandlersAfter = require('coact-utils/linkHandlersAfter');

var _linkHandlersAfter2 = _interopRequireDefault(_linkHandlersAfter);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function buildQuery(keys, input) {
  if (!input) return {};

  var fieldQuery = { $regex: input, $options: 'i' };
  var query = { $or: [] };
  keys.forEach(function (key) {
    return query.$or.push(_defineProperty({}, key, fieldQuery));
  });
  return query;
}

var onInputChange = function onInputChange(props) {
  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(input) {
      var reference, refKeys, setOptions, server, _ref2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reference = props.reference, refKeys = props.refKeys, setOptions = props.setOptions, server = props.server;
              _context.prev = 1;
              _context.next = 4;
              return server.get({
                url: '/api/model/' + reference,
                query: {
                  query: buildQuery(refKeys, input),
                  populateall: true
                }
              });

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;

              setOptions(data);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](1);

              console.error('lazyFetchOptions Error: ', _context.t0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    array = _propTypes2.default.array,
    object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _getContext2.default)({ server: object }), (0, _injectProps2.default)({
  schema: shape({
    reference: string.isRequired,
    refKeys: array
  }).isRequired
}), (0, _flattenProp2.default)('schema'), (0, _withState2.default)('options', 'setOptions', []), (0, _withHandlers2.default)((0, _linkHandlersAfter2.default)({ onInputChange: onInputChange })), (0, _exposeProps2.default)(['options', 'onInputChange']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'fetchOptionsOnInputChange');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/fetchOptionsOnInputChange.js
// module id = 1640
// module chunks = 0